import {load_one} from "@/store/action-helpers";

export default {

    loadOne: load_one('forms/:id'),

}
